import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchFileDownload } from 'api/file-download.service';
import { notificationActions } from 'redux/notification/notification.slice';
import { initialFileDownloadUrlResponseValue } from 'redux/initial-state';
import { FileDownloadAndNewArrivalNotificationRequest } from 'types/entity/file-download-and-new-arrival-notification-request';
import { FileDownloadUrlResponse } from 'types/entity';

export const FOLLOW_FILE_DOWNLOAD_STORE_NAME = 'followFileDownload';

export const loadFileDownload = createAsyncThunk(
  `${FOLLOW_FILE_DOWNLOAD_STORE_NAME}/load`,
  async (
    payload: {
      projectId: string;
      fileDownloadAndNewArrivalNotificationRequest: FileDownloadAndNewArrivalNotificationRequest;
    },
    thunkAPI,
  ) => {
    const response = await fetchFileDownload(payload.projectId, payload.fileDownloadAndNewArrivalNotificationRequest)
      .catch((error) => {
        thunkAPI.dispatch(notificationActions.addWarning({ messageId: '/error/S-CAPI-FP-005005/0001' }));
        throw new Error(error);
      });
    return response;
  },
);

export type FollowFileDownloadState = {
  entity: FileDownloadUrlResponse
  error: any
  loadingMap: {[requestId: string]: boolean}
}

export const initialFollowFileDownloadListResponseState: FollowFileDownloadState = {
  entity: initialFileDownloadUrlResponseValue,
  error: null,
  loadingMap: {},
};

export const fileDownloadSlice = createSlice({
  name: FOLLOW_FILE_DOWNLOAD_STORE_NAME,
  initialState: initialFollowFileDownloadListResponseState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(loadFileDownload.pending, (state, action) => {
      state.loadingMap[action.meta.requestId] = true;
    });
    builder.addCase(loadFileDownload.fulfilled, (state, action) => {
      state.entity = action.payload;
      delete state.loadingMap[action.meta.requestId];
    });
    builder.addCase(loadFileDownload.rejected, (state, action) => {
      state.error = action.payload;
      delete state.loadingMap[action.meta.requestId];
    });
  },
});

export const fileDownloadAction = {
  ...fileDownloadSlice.actions,
  loadFileDownload,
};

export default fileDownloadSlice.reducer;
